module.exports = __webpack_public_path__ + "static/img/duom08.b88fe50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom08.png
// module id = 984
// module chunks = 0